import React, { FC } from 'react'

import cn from 'classnames'

import classes from './tabbed-bar.module.scss'
import { TabProps } from './tabbed-bar.types'

export const TabbedBar: FC<TabProps> = ({
  activeTab,
  onTabClick,
  tabContent,
  externalClasses,
}) => {
  return (
    <div className={cn(classes.root, externalClasses?.root)} data-testid="tabs">
      {tabContent.map((tab, index) => (
        <button
          className={cn(
            classes.tabSection,
            { active: activeTab === tab.value },
            externalClasses?.tabSection
          )}
          aria-label={tab.ariaLabel}
          data-item-category={tab.dataItemCategory}
          data-item-name={tab.dataItemName}
          data-testid={tab.dataItemName}
          data-test-active-tab={activeTab === tab.value}
          key={index}
          onClick={() => onTabClick(tab.value)}
          tabIndex={0}
        >
          {tab.tabName}
        </button>
      ))}
    </div>
  )
}

export default TabbedBar
